import { List, Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import FilterDefinitionValueRecord from '~/ducks/machine-filter-v2/data/FilterDefinitionValueRecord';
import NameRecord from '~/ducks/machine-filter-v2/data/NameRecord';
import type {
  FilterDefinitionTypeBaseFields,
  FilterDefinitionTypeMethods,
} from './FilterTypeDefinitionBase';
import { baseKeys } from './FilterTypeDefinitionBase';

const keys: Fields = {
  ...baseKeys,
  name: NameRecord.createTagsNameRecord(''),
  options: List(),
  type: FilterDefinitionTypeConstants.MULTI_SELECT_TAGS,
};

export interface Fields extends FilterDefinitionTypeBaseFields {
  options: List<FilterDefinitionValueRecord>;
  type: FilterDefinitionTypeConstants.MULTI_SELECT_TAGS;
}

export default class TagFilterDefinitionTypeRecord extends Record<Fields>(keys)
  implements FilterDefinitionTypeMethods {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};
    if (values) {
      if (values.options) {
        newValues.options = List(
          values.options.map(
            (option) => new FilterDefinitionValueRecord(option)
          )
        );
      }

      if (values.name) {
        newValues.name = new NameRecord(values.name);
      }
    }

    return this.merge(newValues);
  }

  getFilterKey(): string {
    return this.name.getName();
  }

  getOptions(): List<FilterDefinitionValueRecord> {
    return this.options;
  }

  getLabel(): string | undefined {
    return this.name.getLabel();
  }

  getName(): string {
    return this.getTagCategory();
  }

  getNameRecord(): NameRecord {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getTagCategory(): string {
    return this.name?.getLabel() || 'NO_LABEL';
  }

  getFormattedFilterName(): string {
    return this.getTagCategory();
  }
}
